"use client";

import { createContext, useContext, ReactNode } from "react";
import { useToast, ToastContainer } from "@/components/ui/toast";

interface ToastContextType {
  toast: (toast: {
    title: string;
    description?: string;
    variant?: "default" | "destructive" | "success";
  }) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: ReactNode }) {
  const { toast, toasts, removeToast } = useToast();

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return context;
}
